exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatar-uploader[data-v-7c741afe]{border:1px dashed #d9d9d9;border-radius:6px;cursor:pointer;position:relative;overflow:hidden}.avatar-uploader .el-upload[data-v-7c741afe]:hover{border-color:#409eff}.avatar-uploader-icon[data-v-7c741afe]{font-size:28px;color:#8c939d;width:178px;text-align:center}.avatar[data-v-7c741afe]{width:178px;display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7c741afe","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Pack/Genel/SistemAyarlari.vue
// module id = 408
// module chunks = 0